export default __webpack_public_path__ + "static/media/AddPromotionIcon.ec972810.svg";